import React, { Component } from 'react'
import _ from 'lodash'
import getLabel from '../../utilities/label.js'
import TitleBar from '../TitleBar'

export default class CustomPage extends Component {
  constructor(props) {
    super(props)
    const backButton = '<i class=\'fa fa-arrow-left\'></i> ' + getLabel('back_button')
    var homepage_block = this.getHomepageBlock(props.match.params.id)
    this.state = {
      homepage_block: homepage_block,
      backButton: backButton
    }
    this.props.setActiveTab('homepage')
    window.trackPage('HtmlHomepageBlockScreen', props.match.params.id)
  }

  getHomepageBlock(id) {
    return _.find(this.props.homepage.homepage.homepage_blocks, {id: parseInt(id, 10)})
  }
  render() {
    let title = this.state.homepage_block.title
    return (
      <div>
        <TitleBar
          title={title}
          leftButtonLabel={ this.state.backButton }
          leftButtonAction={ () => window.history.back() }/>
        <div dangerouslySetInnerHTML={{__html: this.state.homepage_block.html_body}} >
        </div>
      </div>
    )
  }
}
